module.exports = __webpack_public_path__ + "assets/fonts/opensans-extrabold-webfont.woff";